import ahoy from 'ahoy.js';
import '../site/theme_live_reload.js'
import '../site/activities.js'

window.ahoy = ahoy
